import { mapGetters } from 'vuex'

export const isScoringEnabled = {
  computed: {
    ...mapGetters('settings', ['isScoringEnabled'])
  }
}
